// let baseUrl = 'https://localhost:7226/api';
// let staffUrl = 'https://localhost:3000';
// let clientUrl = 'https://localhost:3001';
// let publicApiUrl = 'https://localhost:7228';

let baseUrl = 'https://api.hyperflo.net/api';
let staffUrl = 'https://app.hyperflo.net';
let clientUrl = 'https://client.hyperflo.net';
let publicApiUrl = 'https://public-api.hyperflo.net';



// //本地调试用
// let baseUrl = 'http://111.165.61.155:8003/api';
// let staffUrl = 'http://111.165.61.155:8004';
// let clientUrl = 'http://localhost:3001';
// let publicApiUrl = 'http://localhost:7228';

module.exports = {
  config: {
    baseUrl,
    staffUrl,
    clientUrl,
    publicApiUrl,
    footerText: 'Copyright Company Name © 2018',
    aesKey: '5T7y9O3u7H2j5K9L3z2W5x9Q1p6R4v8M',
    aesIV: '37fa77f6a3b0462d',
    format: {
      date: 'DD/MM/YYYY', //格式化时间格式
      sqlDate: 'YYYY-MM-DD'
    },
    setTimeoutMilliSecond: 10,
    networkRetryCount: 2, // ERR_NETWORK 自动重试次数
    networkRetryDelay: 1000, // 每次重试间隔(毫秒)
    //组件相关
    component: {
      size: 'middle', //组件尺寸 large | middle | small
      gutter: [0, 8], //栅格间隔
      margin: 'normal',
      bordered: true, //组件是否有边框
      defaultDeleteConfirmText: 'Do you want to delete this record?', //删除数据时默认的提示文字
      Input: {
        Textarea: {
          rows: 5, //文本域默认行数
        }
      },
      DatePicker: {
        dateFormat: 'DD/MM/YYYY', //日期控件默认格式
        dateTimeFormat: 'DD/MM/YYYY HH:mm',
      },
      Pagination: {
        pageSize: 20, //默认一页行数
        pageSizeOptions: [20, 50, 100], //设置页码可选项
        showSizeChanger: true, //是否可以改变 pageSize
        showTotal: total => `${total} records total`, //显示总条数
        position: ['bottomLeft']
      },
      AutoComplete: {
        minimumQueryCharacters: 2, //最少多少个字符时触发查询自动完成的数据
      },
      Message: {
        style: {
          marginTop: '20vh',
        },
      },
      Modal: {
        maskClosable: false, //点击背景遮罩是否关闭
      },
      Empty: {
        imageStyle: {
          height: 40,
        },
        description: 'No Data'
      },
      Icon: {
        style: {
          fontSize: '18px'
        },
      },
      Image: {
        //加载失败的默认图片
        fallback: "data:image/png;base64,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"
      },
      Table: {
        // scroll: { x: 'max-content' }
        scroll: null,
        fixed: null
      },
      Tooltip: {
        mouseEnterDelay: 0.6
      },
      Button: {
        size: 'middle',
      },
      ColorPicker: {
        defaultColor: '#03a9f4',
      },
      fontColor: {
        defaultColor: '#ffffff',
      },
      CKEditor: {
        config: {
          // 普通富文本允许用户为选中的列表选择编号样式。
          list: {
            properties: {
              styles: true,
            },
          },
          link: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'https://'
          },
          toolbar: {
            items: ['heading', '|', 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|', 'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|', 'numberedList', 'bulletedList', '|', 'outdent', 'indent', '|', 'link', 'blockquote', 'uploadImage', 'insertTable', '|', 'undo', 'redo',]
          },
          fontFamily: {
            options: [
              'default',
              'Arial, Helvetica, sans-serif',
              'Calibri, sans-serif',
              'Courier New, Courier, monospace',
              'Georgia, serif',
              'Times New Roman, Times, serif',
              'Verdana, Geneva, sans-serif',
            ],
            supportAllValues: true,
          },
          fontSize: {
            options: [
              'default',
              { model: '8pt', title: '8' },
              { model: '9pt', title: '9' },
              { model: '10pt', title: '10' },
              { model: '11pt', title: '11' },
              { model: '12pt', title: '12' },
              { model: '14pt', title: '14' },
              { model: '16pt', title: '16' },
              { model: '18pt', title: '18' },
              { model: '20pt', title: '20' },
              { model: '22pt', title: '22' },
              { model: '24pt', title: '24' },
              { model: '28pt', title: '28' },
              { model: '32pt', title: '32' },
              { model: '36pt', title: '36' },
              { model: '48pt', title: '48' },
              { model: '72pt', title: '72' }
            ],
            supportAllValues: true,
          },
          fontBackgroundColor: {
            columns: 12,
            colors: [
              { label: 'Red 50', color: '#ffebee' },
              { label: 'Purple 50', color: '#f3e5f5' },
              { label: 'Indigo 50', color: '#e8eaf6' },
              { label: 'Blue 50', color: '#e3f2fd' },
              { label: 'Cyan 50', color: '#e0f7fa' },
              { label: 'Teal 50', color: '#e0f2f1' },
              { label: 'Light green 50', color: '#f1f8e9' },
              { label: 'Lime 50', color: '#f9fbe7' },
              { label: 'Amber 50', color: '#fff8e1' },
              { label: 'Orange 50', color: '#fff3e0' },
              { label: 'Grey 50', color: '#fafafa' },
              { label: 'Blue grey 50', color: '#eceff1' },
              { label: 'Red 100', color: '#ffcdd2' },
              { label: 'Purple 100', color: '#e1bee7' },
              { label: 'Indigo 100', color: '#c5cae9' },
              { label: 'Blue 100', color: '#bbdefb' },
              { label: 'Cyan 100', color: '#b2ebf2' },
              { label: 'Teal 100', color: '#b2dfdb' },
              { label: 'Light green 100', color: '#dcedc8' },
              { label: 'Lime 100', color: '#f0f4c3' },
              { label: 'Amber 100', color: '#ffecb3' },
              { label: 'Orange 100', color: '#ffe0b2' },
              { label: 'Grey 100', color: '#f5f5f5' },
              { label: 'Blue grey 100', color: '#cfd8dc' },
              { label: 'Red 200', color: '#ef9a9a' },
              { label: 'Purple 200', color: '#ce93d8' },
              { label: 'Indigo 200', color: '#9fa8da' },
              { label: 'Blue 200', color: '#90caf9' },
              { label: 'Cyan 200', color: '#80deea' },
              { label: 'Teal 200', color: '#80cbc4' },
              { label: 'Light green 200', color: '#c5e1a5' },
              { label: 'Lime 200', color: '#e6ee9c' },
              { label: 'Amber 200', color: '#ffe082' },
              { label: 'Orange 200', color: '#ffcc80' },
              { label: 'Grey 200', color: '#eeeeee' },
              { label: 'Blue grey 200', color: '#b0bec5' },
              { label: 'Red 300', color: '#e57373' },
              { label: 'Purple 300', color: '#ba68c8' },
              { label: 'Indigo 300', color: '#7986cb' },
              { label: 'Blue 300', color: '#64b5f6' },
              { label: 'Cyan 300', color: '#4dd0e1' },
              { label: 'Teal 300', color: '#4db6ac' },
              { label: 'Light green 300', color: '#aed581' },
              { label: 'Lime 300', color: '#dce775' },
              { label: 'Amber 300', color: '#ffd54f' },
              { label: 'Orange 300', color: '#ffb74d' },
              { label: 'Grey 300', color: '#e0e0e0' },
              { label: 'Blue grey 300', color: '#90a4ae' },
              { label: 'Red 400', color: '#ef5350' },
              { label: 'Purple 400', color: '#ab47bc' },
              { label: 'Indigo 400', color: '#5c6bc0' },
              { label: 'Blue 400', color: '#42a5f5' },
              { label: 'Cyan 400', color: '#26c6da' },
              { label: 'Teal 400', color: '#26a69a' },
              { label: 'Light green 400', color: '#9ccc65' },
              { label: 'Lime 400', color: '#d4e157' },
              { label: 'Amber 400', color: '#ffca28' },
              { label: 'Orange 400', color: '#ffa726' },
              { label: 'Grey 400', color: '#bdbdbd' },
              { label: 'Blue grey 400', color: '#78909c' },
              { label: 'Red 500', color: '#f44336' },
              { label: 'Purple 500', color: '#9c27b0' },
              { label: 'Indigo 500', color: '#3f51b5' },
              { label: 'Blue 500', color: '#2196f3' },
              { label: 'Cyan 500', color: '#00bcd4' },
              { label: 'Teal 500', color: '#009688' },
              { label: 'Light green 500', color: '#8bc34a' },
              { label: 'Lime 500', color: '#cddc39' },
              { label: 'Amber 500', color: '#ffc107' },
              { label: 'Orange 500', color: '#ff9800' },
              { label: 'Grey 500', color: '#9e9e9e' },
              { label: 'Blue grey 500', color: '#607d8b' },
              { label: 'Red 600', color: '#e53935' },
              { label: 'Purple 600', color: '#8e24aa' },
              { label: 'Indigo 600', color: '#3949ab' },
              { label: 'Blue 600', color: '#1e88e5' },
              { label: 'Cyan 600', color: '#00acc1' },
              { label: 'Teal 600', color: '#00897b' },
              { label: 'Light green 600', color: '#7cb342' },
              { label: 'Lime 600', color: '#c0ca33' },
              { label: 'Amber 600', color: '#ffb300' },
              { label: 'Orange 600', color: '#fb8c00' },
              { label: 'Grey 600', color: '#757575' },
              { label: 'Blue grey 600', color: '#546e7a' },
              { label: 'Red 700', color: '#d32f2f' },
              { label: 'Purple 700', color: '#7b1fa2' },
              { label: 'Indigo 700', color: '#303f9f' },
              { label: 'Blue 700', color: '#1976d2' },
              { label: 'Cyan 700', color: '#0097a7' },
              { label: 'Teal 700', color: '#00796b' },
              { label: 'Light green 700', color: '#689f38' },
              { label: 'Lime 700', color: '#afb42b' },
              { label: 'Amber 700', color: '#ffa000' },
              { label: 'Orange 700', color: '#f57c00' },
              { label: 'Grey 700', color: '#616161' },
              { label: 'Blue grey 700', color: '#455a64' },
              { label: 'Red 800', color: '#c62828' },
              { label: 'Purple 800', color: '#6a1b9a' },
              { label: 'Indigo 800', color: '#283593' },
              { label: 'Blue 800', color: '#1565c0' },
              { label: 'Cyan 800', color: '#00838f' },
              { label: 'Teal 800', color: '#00695c' },
              { label: 'Light green 800', color: '#558b2f' },
              { label: 'Lime 800', color: '#9e9d24' },
              { label: 'Amber 800', color: '#ff8f00' },
              { label: 'Orange 800', color: '#ef6c00' },
              { label: 'Grey 800', color: '#424242' },
              { label: 'Blue grey 800', color: '#37474f' },
              { label: 'Red 900', color: '#b71c1c' },
              { label: 'Purple 900', color: '#4a148c' },
              { label: 'Indigo 900', color: '#1a237e' },
              { label: 'Blue 900', color: '#0d47a1' },
              { label: 'Cyan 900', color: '#006064' },
              { label: 'Teal 900', color: '#004d40' },
              { label: 'Light green 900', color: '#33691e' },
              { label: 'Lime 900', color: '#827717' },
              { label: 'Amber 900', color: '#ff6f00' },
              { label: 'Orange 900', color: '#e65100' },
              { label: 'Grey 900', color: '#212121' },
              { label: 'Blue grey 900', color: '#263238' },
            ]
          }
        },
      },
      CKEditorUploadPublicImage: {
        config: {
          // 带公共图片上传的普通富文本同样支持列表样式选择。
          list: {
            properties: {
              styles: true,
            },
          },
          ckfinder: {
            // 上传图片到后端的 url。
            uploadUrl: baseUrl + '/System/Global/UploadPublicImage',
          },
          link: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'https://'
          },
          toolbar: {
            items: ['heading', '|', 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|', 'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|', 'numberedList', 'bulletedList', '|', 'outdent', 'indent', '|', 'link', 'blockquote', 'uploadImage', 'insertTable', '|', 'undo', 'redo',]
          },
          fontSize: {
            options: [
              'default',
              { model: '8pt', title: '8' },
              { model: '9pt', title: '9' },
              { model: '10pt', title: '10' },
              { model: '11pt', title: '11' },
              { model: '12pt', title: '12' },
              { model: '14pt', title: '14' },
              { model: '16pt', title: '16' },
              { model: '18pt', title: '18' },
              { model: '20pt', title: '20' },
              { model: '22pt', title: '22' },
              { model: '24pt', title: '24' },
              { model: '28pt', title: '28' },
              { model: '32pt', title: '32' },
              { model: '36pt', title: '36' },
              { model: '48pt', title: '48' },
              { model: '72pt', title: '72' }
            ],
            supportAllValues: true,
          },
        },
      },
      EmailSignature: {
        config: {
          // 邮件正文及签名沿用原有列表编辑体验，不显示列表样式选择器。
          list: {
            properties: {
              styles: false,
            },
          },
          ckfinder: {
            // 上传图片到后端的 url。
            uploadUrl: baseUrl + '/System/Global/UploadPublicImage',
          },
          link: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'https://'
          },
          toolbar: {
            items: ['heading', '|', 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|', 'bold', 'italic', 'underline', 'strikethrough', '|', 'alignment', '|', 'numberedList', 'bulletedList', '|', 'outdent', 'indent', '|', 'link', 'blockquote', 'uploadImage', 'insertTable', '|', 'undo', 'redo',]
          },
          fontFamily: {
            options: [
              'default',
              'Arial, Helvetica, sans-serif',
              'Calibri, sans-serif',
              'Courier New, Courier, monospace',
              'Georgia, serif',
              'Times New Roman, Times, serif',
              'Verdana, Geneva, sans-serif',
            ],
            supportAllValues: true,
          },
          fontSize: {
            options: [
              'default',
              { model: '8pt', title: '8' },
              { model: '9pt', title: '9' },
              { model: '10pt', title: '10' },
              { model: '11pt', title: '11' },
              { model: '12pt', title: '12' },
              { model: '14pt', title: '14' },
              { model: '16pt', title: '16' },
              { model: '18pt', title: '18' },
              { model: '20pt', title: '20' },
              { model: '22pt', title: '22' },
              { model: '24pt', title: '24' },
              { model: '28pt', title: '28' },
              { model: '32pt', title: '32' },
              { model: '36pt', title: '36' },
              { model: '48pt', title: '48' },
              { model: '72pt', title: '72' }
            ],
            supportAllValues: true,
          },
        }
      }
    },
    defaultCountry: 'Australia', //默认国家
    states: ['VIC', 'NSW', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'], //州列表
    imageTypes: ['image/jpeg', 'image/png', 'image/bmp', 'image/heic', 'image/heif'], //允许上传的图片格式
    compressibleImageTypes: ['image/jpeg', 'image/png', 'image/bmp'], //浏览器可压缩格式，HEIC/HEIF 交由后端转 JPEG
    uploadImageMaxLength: 600, //上传图片最大尺寸(大于这个值的会被压缩到这个值), KB
    fileUploadLimit: 500, //上传文件最大尺寸(大于这个值的不让上传), MB
    addressFinderKey: 'TERV3X4J6UFKPD7QMCHA',
    psmaKey: 'dWeaHO6dr2ngCyustDJ7bLAir7mAfOpD',
    googleMap: {
      apiKey: 'AIzaSyDfIkiuIbtSPWEhU2qsDqOELne0_slNaNU',
      defaultCenter: {
        lat: -37.768,
        lng: 145.006
      },
      defaultZoom: 11,
      markerStyle: { fontSize: '30px', color: 'red' } //地图上打点的样式
    },
    message: {
      sessionExpired: 'Your session has expired, please login again.' //账户被禁用等情况下, 需要重新登陆的信息
    },
    pattern: {
      email: new RegExp(/^((\s*|\s*,\s*)([&a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*))*$/g, 'i'), //验证电子邮件的正则
      password: new RegExp(/^(?=.*\d)(?=.*[a-zA-Z]).{6,20}$/, 'i') // 验证密码
    },
    sms: {
      mobileStartWith: ['04', '+614']
    },
    color: {
      default: '#03a9f4',
      success: '#28a745',
      danger: '#dc3545',
      inactive: '#6c757d',
    },
    fontColor: '#495057',
    emailRecipient: [{
      value: 'Account/Payer',
      label: 'Account/Payer',
    }, {
      value: 'Accounts',
      label: 'Accounts',
    }, {
      value: 'Agent',
      label: 'Agent',
    }, {
      value: 'Applicant',
      label: 'Applicant',
    }, {
      value: 'AssessingUser',
      label: 'Assessing User',
    }, {
      value: 'AssignedUser',
      label: 'Assigned User',
    }, {
      value: 'Builder',
      label: 'Builder',
    }, {
      value: 'Client',
      label: 'Client',
    }, {
      value: 'ConfirmEmail',
      label: 'Confirm Email',
    }, {
      value: 'Council',
      label: 'Council',
    }, {
      value: 'Inspection Report Recipient',
      label: 'Inspection Report Recipient',
    }, {
      value: 'OfficeEmail',
      label: 'Office Email',
    }, {
      value: 'Owner',
      label: 'Owner',
    }, {
      value: 'Project Manager',
      label: 'Project Manager',
    }, {
      value: 'ReferralCompany',
      label: 'Referral Company',
    }, {
      value: 'SignoffUser',
      label: 'Signoff User',
    }]
  }
}
